define('shared/initializer/form/adapters/mixins/fields/City',[
    '../../../constants',
    './EFECCity',
    'shared/lib/RSVP'
], function (
    constants, 
    EFECCity,
    RSVP
) {
    'use strict';

    function Ctor () {
    }

    function renderOtherCity($city, $cityother, $cityotherWrapper) {
        if($city.val() == 'other') {
            $cityotherWrapper.show();
            $cityother.val('').removeAttr('disabled');
        }
        else {
            $cityotherWrapper.hide();
            $cityother.val('').attr('disabled','disabled');
        }
    }

    var p = Ctor.prototype;

    p.doPageLoad = function() {
        var me = this;
        var fieldCity = me.items[constants.FIELD.CITY];
        var fieldCityOther = me.items[constants.FIELD.CITY_OTHER];

        if (fieldCity == null || fieldCityOther == null) {
            return RSVP.resolve();
        }

        return RSVP.resolve()
            .then(function(){
                renderOtherCity(fieldCity.$el, fieldCityOther.$el, fieldCityOther.$wrap);
            });
    };

    return Ctor;
});
